/* istanbul ignore file */
import React from 'react';
import { UpdateBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import SingleAssetBreadcrumbs from 'domain/finance/assets/shared/SingleAssetBreadcrumbs';

const UpdateAssetBreadcrumbs = () => {
  return (
    <SingleAssetBreadcrumbs>
      <UpdateBreadcrumbItem entity="Asset" />
    </SingleAssetBreadcrumbs>
  );
};

export default UpdateAssetBreadcrumbs;
